<template>
  <div class="row">
    <slot></slot>
  </div>
</template>

<script>
export default {
	name: 'row',
	created () {

	}
}
</script>



// WEBPACK FOOTER //
// Row.vue?27c7b443